class CannotSignupModalController {
  constructor() {
    this.avoidCallbackOnClose = true;
  }
}

export default CannotSignupModalController;



// WEBPACK FOOTER //
// ./client/app/components/cannotSignupModal/cannotSignupModal.controller.js